module.exports = __webpack_public_path__ + "images/director-exploder.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/director/director-exploder.png
// module id = 33
// module chunks = 0